import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'errorMessageFG'
})

export class ErrorMessageFgPipe implements PipeTransform {
  transform(errors: any): string {
    if (errors.required) {
      return 'O campo é obrigatório';
    } else if (errors.minlength) {
      return `O campo deve possuir pelo menos ${errors.minlength.requiredLength} caracteres`;
    } else if (errors.confirmPassword) {
      return 'As senhas devem ser iguais';
    }

    return '';
  }
}
